(() => {
  const key = 'kas:last-shopping-url:v1';
  const selector = 'a[data-kas-continue-shopping]';
  function shoppingURL(value) {
    if (!value) return null;
    try {
      const url = new URL(value, location.origin);
      if (url.origin !== location.origin) return null;
      if (!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:collections(?:\/|$)|products\/)/i.test(url.pathname)) return null;
      return url.pathname + url.search + url.hash;
    } catch (_) { return null; }
  }
  function readURL() {
    try { return shoppingURL(sessionStorage.getItem(key)); }
    catch (_) { return null; }
  }
  function remember() {
    const current = shoppingURL(location.href);
    if (current) {
      try { sessionStorage.setItem(key, current); } catch (_) {}
    }
  }
  function destination() {
    return readURL() || shoppingURL(document.referrer);
  }
  function updateLinks() {
    const target = destination();
    if (target) document.querySelectorAll(selector).forEach(link => { link.href = target; });
  }
  remember();
  updateLinks();
  window.addEventListener('pageshow', () => { remember(); updateLinks(); });
  document.addEventListener('shopify:section:load', updateLinks);
  document.addEventListener('click', event => {
    const link = event.target.closest && event.target.closest(selector);
    if (!link) return;
    const target = destination();
    if (target) link.href = target;
  }, true);
})();
